import { render, staticRenderFns } from "./HrSalaryWealBiz.vue?vue&type=template&id=3bc6dae4&scoped=true&"
import script from "./HrSalaryWealBiz.vue?vue&type=script&lang=js&"
export * from "./HrSalaryWealBiz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc6dae4",
  null
  
)

export default component.exports